import React from 'react';
import { Grid } from '@mui/material';
import { Select } from '../../Common';
import { TranslateW } from "../../../Utils/Languages/Translate";

const LaborHours = ({
    formState,
    setGlobalState,
    dropdownOptions,
    isEditing,
    isAdmin,
}) => (
    <Grid container spacing={2} justifyContent='center'>
        <Grid item xs={12} md={6} align='center'>
            <Select
                label={TranslateW("serviceEventView.enterLaborHours.labor-hours-for-activity") }
                value={formState.laborTimeMinutes}
                onChange={e => setGlobalState("laborTimeMinutes", e.target.value)}
                options={dropdownOptions.laborHours}
                disabled={isEditing}
            />
        </Grid>
        {isAdmin ? (
            <Grid item xs={12} md={6} align='center'>
                <Select
                    label={TranslateW("GLCode") }
                    value={formState.glcodesId}
                    onChange={e => setGlobalState("glcodesId", e.target.value)}
                    options={dropdownOptions.glCodes}
                    disabled={isEditing}
                />
            </Grid>
        ): (
            <Grid item xs={12} />
        )}
    </Grid>
);

export default LaborHours;
